{
  "sdk-download-android": "تنزيل لنظام Android",
  "sdk-connect": "اتصال",
  "sdk-download-ios": "تنزيل لنظام iOS",
  "sdk-install": "تثبيت",
  "sdk-modal-instruct-1": "1. افتح تطبيق Binance",
  "sdk-modal-instruct-2": "2. اضغط {{icon}} على الشاشة الرئيسية",
  "sdk-modal-title": "الربط مع Binance (بينانس)",
  "sdk-no-app": "ليس لديك تطبيق Binance حتّى الآن؟"
}